import React from 'react';
import {
  RiBarChartBoxLine,
  RiFileChartLine,
  RiScan2Line,
  RiShieldCheckLine,
  RiUploadCloud2Line,
  RiWallet3Line,
} from 'react-icons/ri';

const features = [
  {
    icon: RiUploadCloud2Line,
    title: 'Déposez votre facture',
    description:
      'Photographiez ou importez un PDF : Easy Compta extrait les montants, dates et TVA, puis prépare vos écritures.',
  },
  {
    icon: RiScan2Line,
    title: 'Saisie automatique',
    description:
      'Fini la ressaisie manuelle. Vos champs se remplissent tout seuls - l\'IA travaille en arrière-plan pour vous.',
  },
  {
    icon: RiWallet3Line,
    title: 'Wave, Orange Money & plus',
    description:
      'Centralisez caisse, banque, Wave et Orange Money. Toute votre trésorerie au même endroit.',
  },
  {
    icon: RiBarChartBoxLine,
    title: 'Tableau de bord clair',
    description:
      'Visualisez revenus, dépenses et soldes en temps réel. Comprenez votre activité en un coup d\'œil.',
  },
  {
    icon: RiFileChartLine,
    title: '5 rapports PDF',
    description:
      'Bilan, balance, grand livre, livre journal et compte de résultat - prêts à partager avec votre comptable.',
  },
  {
    icon: RiShieldCheckLine,
    title: 'Conforme SYSCOHADA',
    description:
      'Plan comptable OHADA intégré, adapté au contexte fiscal sénégalais. Vos données restent sécurisées.',
  },
];

const FeaturesSection = () => {
  return (
    <section id="fonctionnalites" className="lp-section lp-features">
      <div className="lp-container">
        <header className="lp-section-header lp-reveal">
          <div className="lp-badge">
            <span className="lp-badge-dot" />
            Comment ça marche
          </div>
          <h2 className="lp-title">
            Vous déposez, <span className="lp-title-accent">on fait le reste</span>
          </h2>
          <p className="lp-subtitle lp-subtitle-center">
            De la facture au rapport PDF : tout le parcours comptable, sans
            complexité
          </p>
        </header>

        <div className="lp-features-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <article
                key={feature.title}
                className={`lp-feature-card lp-reveal lp-reveal-delay-${(index % 4) + 1}`}
              >
                <div className="lp-feature-icon">
                  <Icon />
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
